import PropTypes from "prop-types"
import { Box, Typography } from "@mui/material"
import { AutoMode } from "@mui/icons-material"
import "./style.scss"

export default function AnimatedLoadingButton({ text = "Optimizing..." }) {
  return (
    <Box className="components_animated-loading-button">
      <Box className="animated-loading-button-icon">
        <AutoMode />
      </Box>
      <Typography variant="button">
        {text}
      </Typography>
    </Box>
  )
}

AnimatedLoadingButton.propTypes = {
  text: PropTypes.string,
}
